import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import {
    Box,
    CoinsIcon,
    Link,
    MenuHamburger,
    MeterIcon,
    Sidebar as SidebarBO,
    SidebarItem,
    SidebarList,
    SidebarMenu,
    SidebarMenuCategory,
    Text,
    Topbar,
    InternalGrid,
    CartIcon,
    LeafIcon,
} from '@paygreen/paygreen-ui';
import { LogoPaygreen, ClimateKitBadge } from '../../assets/logos';
import { IsDesktop } from '../../utils/tools';
import IconByName from '../../utils/IconByName';
import { ModeDisplay } from '../index';

const ContactWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const SideBar = (props) => {
    const { t, isOpen, toggleIsOpen } = props;

    const SidebarItemWrapper = (props) => {
        const linksProps = {
            colorPallet: props.isInsideList ? 'wab' : 'theme',
            colorWab: 'grey60',
            hasUnderline: false,
        };

        return (
            <RouterLink
                to={props.to}
                onClick={IsDesktop() ? null : () => toggleIsOpen(!isOpen)}
            >
                <SidebarItem
                    isActive={window.location.pathname === props.to}
                    paddingLateral="md"
                >
                    {!props.isInsideList && (
                        <IconByName name={props.icon} iconSize="lg" />
                    )}

                    <Link {...linksProps}>
                        {t(`sidebar.${props.translationId}`)}
                    </Link>
                </SidebarItem>
            </RouterLink>
        );
    };

    return (
        <SidebarBO
            style={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Topbar className="hideOnDesktop">
                <InternalGrid childrenMarginLateral="sm" alignItems="center">
                    <ClimateKitBadge />

                    <ModeDisplay hasDot={false} />
                </InternalGrid>

                <MenuHamburger
                    arrowDirection="left"
                    colorPallet="wab"
                    isOpen={true}
                    onClick={() => toggleIsOpen(!isOpen)}
                />
            </Topbar>
            <Box margin="md" className="hideOnTablet">
                <RouterLink to="/">
                    <LogoPaygreen badge={<ClimateKitBadge />} />
                </RouterLink>

                <ModeDisplay hasDot={false} justifyContent="flex-start" />
            </Box>
            <InternalGrid style={{ overflowY: 'auto', flex: 1 }}>
                <SidebarMenuCategory style={{ width: '100%' }}>
                    <SidebarMenu>
                        <SidebarItem // is necessary here because SidebarMenu automatically passes function to open/close SidebarList to SidebarItem from PG-UI only
                            htmlTag="button"
                            isOpen={true}
                            paddingLateral="md"
                        >
                            <MeterIcon iconSize="lg" />

                            <Link hasUnderline={false}>
                                {t('sidebar.emissionsTitle')}
                            </Link>
                        </SidebarItem>

                        <SidebarList isOpen={true}>
                            <SidebarItemWrapper
                                to="/"
                                translationId="dashboardTitle"
                                isInsideList
                            />

                            <SidebarItemWrapper
                                to="/offsets"
                                translationId="offsettingTitle"
                                isInsideList
                            />
                        </SidebarList>
                    </SidebarMenu>

                    <SidebarMenu>
                        <SidebarItem
                            htmlTag="button"
                            isOpen={true}
                            paddingLateral="md"
                        >
                            <CoinsIcon iconSize="lg" />

                            <Link hasUnderline={false}>
                                {t('sidebar.contributionsTitle')}
                            </Link>
                        </SidebarItem>
                        <SidebarList isOpen={true}>
                            <SidebarItemWrapper
                                to="/contributions/global-view"
                                translationId="globalViewTitle"
                                isInsideList
                            />
                            <SidebarItemWrapper
                                to="/contributions/my-contributions"
                                translationId="myContributionsTitle"
                                isInsideList
                            />
                        </SidebarList>
                    </SidebarMenu>

                    <SidebarMenu>
                        <SidebarItem
                            htmlTag="button"
                            isOpen={true}
                            paddingLateral="md"
                        >
                            <LeafIcon iconSize="lg" />
                            <Link hasUnderline={false}>
                                {t('sidebar.projectsTitle')}
                            </Link>
                        </SidebarItem>

                        <SidebarList isOpen={true}>
                            <SidebarItemWrapper
                                to="/projects/user/my-project"
                                translationId="myCarbonTitle"
                                isInsideList
                            />
                            <SidebarItemWrapper
                                to="/projects"
                                translationId="allProjects"
                                isInsideList
                            />
                        </SidebarList>
                    </SidebarMenu>

                    <SidebarMenu>
                        <SidebarItem
                            htmlTag="button"
                            isOpen={true}
                            paddingLateral="md"
                        >
                            <CartIcon iconSize="lg" />

                            <Link hasUnderline={false}>
                                {t('sidebar.matchingTitle')}
                            </Link>
                        </SidebarItem>
                        <SidebarList isOpen={true}>
                            <SidebarItemWrapper
                                to="/sectors"
                                isInsideList
                                translationId="sectorTitle"
                            />
                        </SidebarList>
                        <SidebarList isOpen={true}>
                            <SidebarItemWrapper
                                to="/categories"
                                isInsideList
                                translationId="categoriesTitle"
                            />
                        </SidebarList>
                        <SidebarList isOpen={true}>
                            <SidebarItemWrapper
                                to="/products"
                                isInsideList
                                translationId="matchingProductsTitle"
                            />
                        </SidebarList>
                    </SidebarMenu>
                </SidebarMenuCategory>
            </InternalGrid>

            <ContactWrapper>
                <Text
                    align="center"
                    textSize="xs"
                    colorWab="grey40"
                    marginBottom="lg"
                >
                    {t('sidebar.questions')}

                    <a href="mailto:serviceclient@paygreen.fr">
                        <Link colorPallet="theme" hasUnderline={false}>
                            {t('login.helpLink')}
                        </Link>
                    </a>
                </Text>
            </ContactWrapper>
        </SidebarBO>
    );
};

export default withTranslation('common')(SideBar);
